import { Injectable, signal } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class DeviceDetectionService {
  private readonly MOBILE_MAX_WIDTH = 768;
  readonly isMobile = signal(this.checkIsMobile());

  constructor() {
    window.addEventListener('resize', () => {
      this.isMobile.set(this.checkIsMobile());
    });
  }

  private checkIsMobile(): boolean {
    return this.isSmallScreen() || this.isMobileUserAgent();
  }

  private isSmallScreen(): boolean {
    return window.innerWidth <= this.MOBILE_MAX_WIDTH;
  }

  private isMobileUserAgent(): boolean {
    const ua = navigator.userAgent || '';
    return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(ua);
  }
}
